import axios from "axios";

// Both flows use the same authenticated commit. The server, not this payload,
// decides whether card evidence is required and revalidates room availability.
export async function commitBookingDraftGroup({
  apiUrl = "",
  groupId,
  publicSessionToken,
  language,
  currencyCode,
  fxRateSetId,
  updatedBy = "PublicBookingCommit",
}) {
  const id = Number(groupId);
  const token = String(publicSessionToken || "").trim();
  if (!Number.isSafeInteger(id) || id <= 0 || !token) {
    throw new Error("Missing booking session");
  }
  const base = String(apiUrl || "").replace(/\/+$/, "");
  const { data } = await axios.post(
    `${base}/api/reservation-draft-groups2/${id}/commit`,
    {
      updated_by: updatedBy,
      booking_engine_language: String(language || "").trim() || null,
      currency_code: currencyCode || null,
      fx_rate_set_id: fxRateSetId || null,
    },
    { headers: { "x-public-session-token": token } }
  );
  if (data?.ok !== true) {
    const error = new Error("Booking confirmation failed");
    error.response = { data };
    throw error;
  }
  return {
    commit: data,
    reservation_group_locator: data.reservation_group_locator || data.group_locator || null,
  };
}
